export function isValidEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function isCapsLockOn(e: KeyboardEvent) {
  return e.getModifierState('CapsLock');
}

export function getCurrentRef() {
  let localRef = { path: '/' };

  try {
    const item = localStorage.getItem('ref');

    if (item) {
      localRef = JSON.parse(item);
    }
  } catch (err) {} // eslint-disable-line

  return localRef;
}
